import { Component, OnInit, PLATFORM_ID, Inject, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CookieConsentService, ConsentSettings } from '../../services/cookie-consent.service';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-cookiebanner',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.css']
})
export class CookieBannerComponent implements OnInit {
  hasAnswered = true; // Standardmäßig versteckt, bis Überprüfung abgeschlossen
  bannerInitialized = false;
  consentSettings: ConsentSettings;
  showAcceptSelection: boolean = false;
  isBrowser: boolean;
  
  constructor(
    private cookieService: CookieConsentService,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    // Initialisierung mit Default-Werten
    this.consentSettings = {
      necessary: true,
      preferences: false,
      statistics: false,
      marketing: false,
      timestamp: 0,
      version: '1.0'
    };
  }
  
  ngOnInit(): void {
    if (!this.isBrowser) return;
    
    // Mit kleiner Verzögerung ausführen, um DOM-Rendering zu ermöglichen
    setTimeout(() => {
      this.hasAnswered = this.cookieService.hasAnswered();
      this.loadCurrentSettings();
      
      if (!this.hasAnswered) {
        // Nur bei Erstbesuch oder wenn keine Antwort vorliegt Banner initialisieren
        this.bannerInitialized = true;
      }
    }, 300);
    
    // Abonnieren des Banner-Anzeige-Signals
    this.cookieService.showBanner$.subscribe(show => {
      if (show) {
        // Bei erneuter Anzeige des Banners die aktuellen Einstellungen laden
        this.loadCurrentSettings();
        this.optConsent();
        this.hasAnswered = false;
        setTimeout(() => {
          this.bannerInitialized = true;
        }, 100);
      }
    });
  }

  optConsent() {
    if(this.consentSettings.marketing || this.consentSettings.preferences || this.consentSettings.statistics) {
      this.showAcceptSelection = true
    } else {
      this.showAcceptSelection = false
    }
  }
  
  // Methode zum Laden der aktuellen Cookie-Einstellungen
  private loadCurrentSettings(): void {
    if (this.cookieService.hasAnswered()) {
      const settings = this.cookieService.getConsentSettings();
      if (settings) {
        this.consentSettings = { ...settings };
      }
    }
  }
  
  acceptSelected(): void {
    this.cookieService.acceptConsent(this.consentSettings);
    this.hasAnswered = true;
    this.bannerInitialized = false;
  }
  
  acceptAll(): void {
    this.consentSettings = {
      ...this.consentSettings,
      necessary: true,
      preferences: true,
      statistics: true,
      marketing: true
    };
    this.cookieService.acceptConsent(this.consentSettings);
    this.hasAnswered = true;
    this.bannerInitialized = false;
  }
  
  decline(): void {
    this.cookieService.declineConsent();
    // Aktualisiere auch die lokalen Einstellungen
    this.consentSettings = {
      necessary: true,
      preferences: false,
      statistics: false,
      marketing: false,
      timestamp: Date.now(),
      version: '1.0'
    };
    this.hasAnswered = true;
    this.bannerInitialized = false;
  }
}